import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  const all = [{
    label: '我的分组',
    value: 1,
    node: 1,
  }, {
    label: '团队分组',
    value: 2,
    node: 1,
  }]
  all[0].children = result.myGroupList.map(m => ({ label: m.groupName, value: m.groupId, node: 2, parent: all[0] }))
  all[1].children = result.teamGroupList.map(m => ({ label: m.groupName, value: m.groupId, node: 2, parent: all[1] }))

  return all
}
export default (props) => {
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchStore()
  }, [])

  const fetchStore = async () => {
    try {
      const res = await request.sget('/group/type-group-list-new')
      setOptions(convert(res))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select.Cascade
    {...props}
    trigger="click"
    placeholder="不限"
    data={options}
    defaultLeftValue={1}
    placement="bottomRight"
    hiddenSelected
    hiddenSearch
    rootSelectable
  />
}
